import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { ShoppingBag } from "@faire/web--source/slate/icons/foundation/ShoppingBag";
import React from "react";

import { SelfServeNodes } from "../../types";

export const useHowFaireWorksRetailerNodes = (): SelfServeNodes => {
  const { strictLocalize } = useStrictLocalization();
  const articles = useArticles();
  return {
    HowFaireWorks: {
      id: "HowFaireWorks",
      label: strictLocalize({
        defaultMessage: "How Faire works",
        description: {
          text: "A top level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      icon: <ShoppingBag fontSize="24px" color="faireBlack" />,
      articles: [
        articles.FAQ.RETAILER_WHAT_IS_FAIRE,
        articles.PaymentsAndInvoices.NET_60_TERMS,
        articles.MyOrders.FAIRE_PROTECTION,
        articles.GettingStarted.RESELLER_ID,
      ],
      level: 1,
      sidebarTitle: strictLocalize({
        defaultMessage: "How does Faire work",
        description: {
          text: "Title for displaying the issue on the order summary sidebar",
        },
      }),
    },
  };
};
